export type ImageProps = {
  src: string;
  width: number;
  height: number;
  alt: string;
  sizes?: string;
  srcSet?: string;
  loading?: 'lazy' | 'eager';
  className?: string;
};

function Image({
  src,
  width,
  height,
  sizes,
  srcSet,
  alt,
  loading = 'eager',
  className,
}: ImageProps) {
  return (
    <img
      src={src}
      srcSet={srcSet}
      sizes={sizes}
      width={width}
      height={height}
      loading={loading}
      alt={alt}
      className={className}
    />
  );
}

export default Image;
